<template>
    <div class="booking-panel__wrap">
        <img src="/assets/images/solarPowerSun.svg" width="40" height="40" alt="" loading="lazy" />
        <div>
            <p class="booking__headline">{{dictionary.BookingFlowSolarPoweredHeadline}}</p>
            <p class="booking__message">{{dictionary.BookingFlowSolarPoweredText}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "solarPowered",
    data() {
        return {
            dictionary:[]
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetSolarPoweredDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
};
</script>
